import { withRouter } from 'react-router';
import { useHistory } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import '../../../../Utility/Public/css/theme.css';
import PropTypes from 'prop-types';

const ChatInput = (props) => {

	return (
		<div className='inputChatBox'>
			<div className='inputChatBoxleft'>
				<textarea name="postContent" rows={4} cols={40} onChange={props.followUpChatInputFn} value={props.followUpChatInput} />
			</div>
			<div className='inputChatBoxRight'>
				<button className='sendNamebtn' onClick={props.sendButttonFn}><i className="fa fa-paper-plane" aria-hidden="true"></i>
				</button>
			</div>
		</div>
	);
}




const mapStateToProps = (globalState) => {
	return {
		userCredentials: globalState.LoginReducer.userCredentials,
		token: globalState.LoginReducer.token
	};
}


export default withRouter(connect(mapStateToProps)
	(ChatInput));



